import { QuickLinksTabsComponent } from '../../components/QuickLinks';
import { quickLinksMock } from './mock';

export const QuickLinks = () => {
  const tabs = quickLinksMock;

  if (tabs.length === 0) {
    return null;
  }

  return <QuickLinksTabsComponent tabs={tabs} />;
};
